const CANADIAN_PROVINCES = new Set([
    'AB', 'BC', 'MB', 'NB', 'NL', 'NS', 'NT', 'NU', 'ON', 'PE', 'QC', 'SK', 'YT',
]);

export function isCanadianLocation(state: string | null | undefined): boolean {
    const normalized = (state ?? '').trim().toUpperCase();
    return CANADIAN_PROVINCES.has(normalized);
}
